/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingoverviewtitle2Inputs */

const en_crosspostingoverviewtitle2 = /** @type {(inputs: Crosspostingoverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post Overview`)
};

const de_crosspostingoverviewtitle2 = /** @type {(inputs: Crosspostingoverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitragsübersicht`)
};

/**
* | output |
* | --- |
* | "Post Overview" |
*
* @param {Crosspostingoverviewtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingoverviewtitle2 = /** @type {((inputs?: Crosspostingoverviewtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingoverviewtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingoverviewtitle2(inputs)
	return de_crosspostingoverviewtitle2(inputs)
});
export { crosspostingoverviewtitle2 as "crosspostingOverviewTitle" }